/** * Vendors ***/

import { Fragment, useContext, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { FiChevronsDown } from "react-icons/fi";

import { LayoutContext } from "common/contexts";
import {
  AutoConvertPriceWithUnit,
  convertPriceOnString,
  LocalStorageAutoConvertPrice,
} from "common/priceConvert";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title/index";
import Toast from "components/atoms/Toast/index";
import PackageModal from "components/molecules/PackageModal";
import FormDownloadModal from "components/templates/common/post/FormDownloadModal";

import styles from "./Index.module.scss";

/** * Components ***/

/** * ========== ***/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */
const ChildContent = ({ content }) => {
  if (content) {
    return (
      <ul>
        {content.map((item, index) => {
          return (
            <li key={index}>
              <div
                className="inline-block pl-7 font-medium text-bbc-primary"
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  return <></>;
};

const ContentDynamicPrice = ({ item }) => {
  if (item.paramsContent && item.paramsContent.price) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: convertPriceOnString({ ...item, content: item.text }),
        }}
      />
    );
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: item.text,
      }}
    />
  );
};

const ActionContent = ({ list, dataSuffix }) => {
  const [modalShow, setModalShow] = useState(false);
  const [showFormDownload, setShowFormDownload] = useState(false);

  return (
    <>
      {list.checkName && (
        <Fragment>
          <Toast>
            <PackageModal
              country_name={dataSuffix?.name}
              country_id={dataSuffix?.id}
              show={modalShow}
              onHide={() => setModalShow(false)}
              suffix_data={dataSuffix?.suffixData}
            />
          </Toast>
        </Fragment>
      )}
      {list.ebook_download && (
        <FormDownloadModal
          show={showFormDownload}
          onHide={() => setShowFormDownload(false)}
          typeFormDownload="checklist_delaware"
        />
      )}
      <div
        className="relative  cursor-pointer"
        id={list.hash_id ? list.hash_id : null}
        onClick={() => {
          list.checkName && setModalShow(true);
          // : list.ebook_download &&
          //   (list.dataForm
          //     ? showEbookBookModal(list.checklist_url)
          //     : showEbookBookModal(list.hash_id));
        }}
      >
        <div className="btn inline-block font-medium text-bbc-primary underline">
          <ContentDynamicPrice item={list} />
        </div>
        {list.childContent && <ChildContent content={list.childContent} />}
      </div>
    </>
  );
};

export const ContentList = ({ content, dataPackage, indexEntity }) => {
  const { listContent, bottomContent } = content;

  const countryId = dataPackage?.entitySuffix?.id;
  const dataSuffix = {
    id: countryId,
    name: dataPackage?.entitySuffix?.sub_name,
    suffixData: dataPackage?.entitySuffix?.EntityTypes[indexEntity],
  };

  return (
    <>
      {listContent && (
        <ul className="pl-1.5">
          {listContent.map((list, listIdx) => {
            return (
              <li key={listIdx} className="mb-2 flex items-start last:mb-0 ">
                {!list.notCheck && (
                  <FaCheck
                    className=" mr-2.5 mt-1.5 text-bbc-brand-500"
                    size={12}
                    style={{ minHeight: "12px", minWidth: "12px" }}
                  />
                )}
                <div className="flex flex-col">
                  {/* {list.childContent && (
                    <div className="mt-2 pl-1">
                      <PackageContent
                        content={list.childContent}
                        grid_class={"grid-flow-row"}
                      />
                    </div>
                  )} */}
                  {/* {false ? ( */}
                  {list.checkName || list.ebook_download ? (
                    <ActionContent
                      list={list}
                      dataSuffix={dataSuffix}
                      indexEntity={indexEntity}
                    />
                  ) : (
                    <ContentDynamicPrice item={list} />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      {bottomContent && (
        <div className="mt-2">
          <PackageContent content={bottomContent} grid_class={"grid-flow-r"} />
        </div>
      )}
    </>
  );
};
export const PackageContent = ({
  content,
  grid_class,
  dataPackage,
  indexEntity,
}) => {
  return (
    <div className={`grid ${grid_class || "grid-cols-2"}`}>
      {content.map((item, index) => {
        const { subTitle, listContent, bottomContent } = item;

        return (
          <div
            key={index}
            className={
              listContent
                ? listContent && bottomContent
                  ? "mb-0"
                  : "mb-2 last:lg:mb-8"
                : " mb-0 "
            }
          >
            <>
              {subTitle && (
                <div className="mb-2 flex ">
                  <span
                    className="mr-2 mt-2 h-2 w-2 rounded-full bg-bbc-brand-500"
                    style={{ minHeight: "8px", minWidth: "8px" }}
                  />
                  <div
                    className="font-semibold leading-bbc-26"
                    dangerouslySetInnerHTML={{ __html: subTitle }}
                  />
                </div>
              )}

              {(listContent || bottomContent) && (
                <ContentList
                  content={item}
                  dataPackage={dataPackage}
                  indexEntity={indexEntity}
                />
              )}
            </>
          </div>
        );
      })}
    </div>
  );
};

export const SaleItem = ({ price_unit, sale_off, priceClass, textClass }) => {
  return (
    <div className="font-semibold ">
      <span className={`mr-1 ${textClass || "text-white"}`}>Save</span>
      <span
        className={`inline-block rounded bg-bbc-green-500 p-1 text-sm leading-6 ${
          priceClass || "text-white"
        }`}
      >
        {AutoConvertPriceWithUnit(sale_off, price_unit)}
      </span>
    </div>
  );
};

export const RenewalItem = ({
  price_unit,
  renewal_fee,
  renewal_sub,
  className,
}) => {
  return (
    <div
      className={` ${
        className || "mb-4 text-center text-sm italic  leading-6"
      }`}
    >
      Renewal fee:{" "}
      <div
        className="inline"
        dangerouslySetInnerHTML={{
          __html:
            AutoConvertPriceWithUnit(renewal_fee, price_unit) +
            (renewal_sub || ""),
        }}
      />
    </div>
  );
};

const CardDesktop = (props) => {
  const {
    dataPackage,
    indexEntity,
    name,
    content,
    collapse_content,
    grid_class,
    collapse_grid_class,
    price,
    price_unit,
    sale_off,
    renewal_fee,
    bestSeller,
    fee_bg_color,
    renewal_sub,
    btn_props = {
      othersClass: "border-2 hover:border-bbc-yellow-500",
      btnColor: "bg-transparent hover:bg-bbc-yellow-500",
      btnPadding: "px-10 py-2",
    },
    countryId,
    entity_type_id,
    id,
  } = props;
  const [seeMore, setSeeMore] = useState(false);
  const { currencyUnit } = useContext(LayoutContext);
  const linkRegister = `/onboarding/register?country_id=${countryId}&entity_type_id=${entity_type_id}&package_id=${id}`;

  return (
    <div className="flex overflow-hidden rounded-2xl bg-white ">
      <div className="mr-6 w-3/4 pt-12  pr-0 pl-10">
        <Title
          as="h3"
          text={name}
          className="mb-7 text-[32px] font-semibold uppercase leading-[42px] tracking-[0.25px] text-bbc-brand-700"
        />
        <div className="mb-7 flex items-center justify-between">
          <div
            className={
              " whitespace-nowrap pr-4 text-2xl font-semibold text-bbc-brand-700"
            }
          >
            What&apos;s Included
          </div>
          <div className="h-[1px] w-full border border-bbc-brand-700 " />
        </div>
        <PackageContent
          content={content}
          grid_class={grid_class}
          dataPackage={dataPackage}
          indexEntity={indexEntity}
        />
        {collapse_content && (
          <div className="col-12 mb-8 mt-6">
            <div className={`${styles.collapseContent} `}>
              <div className={`grid ${collapse_grid_class || "grid-cols-2"}`}>
                {collapse_content.map((item, index) => (
                  <div key={index}>
                    <div className="mb-2 flex ">
                      <span
                        className="mr-2 mt-2 h-2 w-2 rounded-full bg-bbc-brand-500"
                        style={{ minHeight: "8px", minWidth: "8px" }}
                      />
                      <div
                        className="font-semibold leading-bbc-26"
                        dangerouslySetInnerHTML={{ __html: item.subTitle }}
                      />
                    </div>
                    <div
                      className={`max-h-0  overflow-hidden ${
                        seeMore && " max-h-[900px]"
                      } transition-all duration-150 ease-linear`}
                    >
                      <ContentList
                        content={item}
                        grid_class={"grid-flow-col"}
                        dataPackage={dataPackage}
                        indexEntity={indexEntity}
                      />
                    </div>
                  </div>
                ))}
              </div>
              {!seeMore && (
                <button
                  className="transition-color mx-auto mt-2 block cursor-pointer font-semibold text-bbc-brand-500 duration-150 hover:text-bbc-brand-700"
                  onClick={() => {
                    setSeeMore(!seeMore);
                  }}
                >
                  {seeMore ? "See Less" : "See More"}
                  <FiChevronsDown
                    className={`inline-block ${
                      seeMore ? "rotate-180" : ""
                    } transition-transform duration-300`}
                    size={16}
                  />
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      <div
        className={`relative w-1/4 overflow-hidden px-4 ${
          fee_bg_color || "bg-bbc-brand-700 "
        }`}
      >
        {bestSeller && (
          <Img
            src="/assets/images/sg/company-incorporation-foreigners/best-seller.png"
            wrapper={{ className: "absolute right-0 top-0" }}
            width={167}
            height={172}
          />
        )}
        <div className="flex h-full w-full flex-col items-center justify-center text-white lg:pt-14 lg:pb-6">
          <div className="">
            <span className=" align-top text-xl font-medium leading-bbc-26">
              {currencyUnit.value || price_unit}
            </span>
            <span className="text-[60px] font-semibold leading-[90px] tracking-[0.25px] ">
              {LocalStorageAutoConvertPrice(price, price_unit)}
            </span>
          </div>
          {sale_off && <SaleItem price_unit={price_unit} sale_off={sale_off} />}
          <div className="mt-7 mb-8 h-0 w-full border-b-2 border-b-white border-opacity-10">
            &nbsp;
          </div>
          {renewal_fee && (
            <RenewalItem {...{ price_unit, renewal_fee, renewal_sub }} />
          )}
          <ButtonNew as="a" href={linkRegister} {...btn_props}>
            Get Started
          </ButtonNew>
        </div>
      </div>
    </div>
  );
};

export default CardDesktop;
